export default "__VITE_ASSET__DFskwrZn__"